<mat-card class="user-panel-wrapper" cdkTrapFocus>
  <div class="user-info" *ngIf="user">
    <sync-avatar [size]="64" [url]="avatarUrl" [initials]="user.display_name | b64"></sync-avatar>
    <div class="user-name h6">{{ user.display_name | b64 }}</div>
    <div class="user-plan body-bold-1">{{ planName }}</div>
    <sync-progress
      *ngIf="!user.is_unlimited_plan"
      [value]="progressValue"
      [class]="getProgressBarColor(progressValue)"
    ></sync-progress>
    <div class="storage-info body-bold-2">
      {{ user.disk_usage_bytes | bytesToSize }} of
      {{ user.is_unlimited_plan ? 'Unlimited' : (user.disk_limit_bytes | bytesToSize) }}
    </div>
  </div>
  <div class="account-options">
    <sync-list [ListItems]="profileMenuItems"></sync-list>
    <sync-divider />
    <sync-list [ListItems]="signOutMenuItems"></sync-list>
  </div>
</mat-card>
